import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { YurticiCargoService } from "../../../../services/YurticiCargoService";

interface Props {
    unitAndRouteInformationRef: any
    selectedExitUnit: CustomSingleSelectModel | undefined
    setSelectedExitUnit: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedArrivalUnit: CustomSingleSelectModel | undefined
    setSelectedArrivalUnit: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDeliveryUnit: CustomSingleSelectModel | undefined
    setSelectedDeliveryUnit: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
}

const UnitAndRouteInformation = ({
    unitAndRouteInformationRef,
    selectedExitUnit,
    setSelectedExitUnit,
    selectedArrivalUnit,
    setSelectedArrivalUnit,
    selectedDeliveryUnit,
    setSelectedDeliveryUnit
}: Props) => {
    return (
        <div className='containerPart' ref={unitAndRouteInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Birim ve Rota Bilgileri</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Çıkış Birimi'
                                isLabelRequired
                                selectedValue={selectedExitUnit}
                                onChange={setSelectedExitUnit}
                                onMenuOpen={() => YurticiCargoService.getYurticiCargoUnitList()}
                                labelName='countyName'
                                valueName='id'
                                label2Name="districtName"
                                label3Name="name"
                                disabled
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Varış Birimi'
                                isLabelRequired
                                selectedValue={selectedArrivalUnit}
                                onChange={setSelectedArrivalUnit}
                                onMenuOpen={() => YurticiCargoService.getYurticiCargoUnitList()}
                                labelName='countyName'
                                valueName='id'
                                label2Name="districtName"
                                label3Name="name"
                                disabled
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText='Teslim Birimi'
                                isLabelRequired
                                selectedValue={selectedDeliveryUnit}
                                onChange={setSelectedDeliveryUnit}
                                onMenuOpen={() => YurticiCargoService.getYurticiCargoUnitList()}
                                labelName='countyName'
                                valueName='id'
                                label2Name="districtName"
                                label3Name="name"
                                disabled
                            />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default UnitAndRouteInformation;